export default "__VITE_ASSET__Dp4gf34A__"